import React, { useEffect } from "react";
import { useUnit } from "effector-react";
import {
  setPage,
  setSelectedVacuum,
  VacuumStore,
} from "../../../../stores/VacuumStore/VacuumStore";
import { PAGES } from "../../../../stores/VacuumStore/VacumStore.types";
import TotemButton from "../../components/TotemButton/TotemButton";
import TotemOption from "../../components/TotemOption/TotemOption";
import TotemSkeleton from "../../components/TotemSkeleton/TotemSkeleton";
import { fetchVacuumCleanersEffect } from "../../../../stores/VacuumStore/VacuumStore.effects";
import { UserStore } from "../../../../stores/UserStore/UserStore";
import { NoVacuums, VacuumsContainer, NoStation } from "./ChooseVacuumStyles";
import { setLoading } from "../../../../stores/MainStore/MainStore";
import { VACUUM_STATUS, VacuumOption } from "../../../../types/vacuum.types";

interface BtnsProps {
  selected?: VacuumOption;
  handleNextStep: () => void;
}

const Buttons = ({ selected, handleNextStep }: BtnsProps) => {
  const text = selected?.name ? "Continuar" : "Selecione uma opcão";

  return (
    <TotemButton
      disabled={!selected?.name}
      onClick={() => handleNextStep()}
      text={text}
    />
  );
};

const ChooseVacuum: React.FC = () => {
  const { vacuumOptions, selectedVacuum } = useUnit(VacuumStore);
  const { station } = useUnit(UserStore);

  useEffect(() => {
    handleGetVacuums();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGetVacuums = () => {
    if (!station) {
      return;
    }

    setLoading(true);

    fetchVacuumCleanersEffect(station).finally(() => {
      setLoading(false);
    });
  };

  const handleNextStep = () => {
    setPage(PAGES.TIME_CHOICE);
  };

  const renderVacuums = () => {
    if (!station) {
      return (
        <NoStation>
          <p>Usuário sem estação, procure um atendente!</p>
        </NoStation>
      );
    }

    if (!vacuumOptions?.length)
      return (
        <NoVacuums onClick={handleGetVacuums}>
          <p>Nenhum aspirador encontrado.</p>
          <p>Clique aqui para tentar novamente</p>
          <p> ou solicite ajuda a um atendente</p>
        </NoVacuums>
      );

    return vacuumOptions.map((vacuum) => {
      const isselected = selectedVacuum?.deviceId === vacuum.deviceId;
      const fixedPrice = vacuum?.pricePerMinute?.toFixed(2).replace(".", ",");
      const priceText = `R$ ${fixedPrice ?? "ERRO"}/minuto`;

      const disabled = vacuum.status === VACUUM_STATUS.LIGADO;

      if (disabled) return <></>;

      return (
        <TotemOption
          key={vacuum.deviceId}
          title={vacuum?.name}
          subtitle={priceText}
          extraText={disabled ? "EM USO" : ""}
          isselected={isselected}
          execSelection={() => setSelectedVacuum(vacuum)}
          disabled={disabled}
        />
      );
    });
  };

  return (
    <TotemSkeleton
      title="Escolha o aspirador"
      buttons={
        <Buttons selected={selectedVacuum} handleNextStep={handleNextStep} />
      }
    >
      <VacuumsContainer>{renderVacuums()}</VacuumsContainer>
    </TotemSkeleton>
  );
};

export default ChooseVacuum;
